import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';
import { Label, label } from '@app/pcs/models/label';
import { SharedOption } from '@app/pcs/models/shared-option';
import { gql } from 'apollo-angular';

export enum LabelColor {
  Violet = 'violet',
  Blue = 'blue',
  Aqua = 'aqua',
  Green = 'green',
  Yellow = 'yellow',
  Orange = 'orange'
}

export interface CreatorUser {
  firstName?: string;
  lastName?: string;
}

export interface UserLabel {
  label?: Label;
  selected?: boolean;
  indeterminate?: boolean;
  sharedType?: SharedOption;
  creator?: boolean;
  creatorUser?: CreatorUser;
  color?: DictionaryEntity;
}

export const userLabel = gql`
  fragment userLabel on UserLabel {
    label {
      ...label
    }
    sharedType
    creator
    creatorUser {
      firstName
      lastName
    }
    color {
      id
    }
  }
  ${label}
`;
